import React from 'react';

import {NucleotideType} from 'biojs/BioConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import {ButtonSize} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import ToggleGroup from 'ui-library/ToggleGroup';

interface NucleotideTypeToggleProps {
  nucleotideType: NucleotideType;
  onChangeSelection: (nucleotideType: NucleotideType) => void;
  disabled?: boolean;
  label?: string;
}

export function NucleotideTypeToggle(props: NucleotideTypeToggleProps): JSX.Element {
  return (
    <FormGroup>
      <FieldLabel label={props.label ?? 'Nucleotide type'} isRequired={true} />
      <ToggleGroup
        options={[
          {
            id: NucleotideType.DNA,
            dataTestAttrs: {component: 'NucleotideTypeToggle', element: 'ToggleGroup', key: 'DNA'},
            buttonProps: {text: 'DNA'},
          },
          {
            id: NucleotideType.RNA,
            dataTestAttrs: {component: 'NucleotideTypeToggle', element: 'ToggleGroup', key: 'RNA'},
            buttonProps: {text: 'RNA'},
          },
        ]}
        selection={props.nucleotideType}
        onChangeSelection={(nucleotideType) => {
          props.onChangeSelection(nucleotideType);
        }}
        size={ButtonSize.SMALL}
        isFullWidth={true}
        disabled={props.disabled}
      />
    </FormGroup>
  );
}
